module.exports = __webpack_public_path__ + "img/comm_total.aa0a4128.png";